import React, { Component } from 'react';
import * as actions from "../../Actions/rules";
import { connect } from "react-redux";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, Checkbox } from '@material-ui/core';
import cssClasses from './rules.css';
import RuleItem from './ruleItem';
import UpdateRuleForm from './UpdateRuleForm';
import Search from './search';
import { PERCENTAGEANDAMOUNT, PERCENTAGE } from "./constants.js";

class ManageRulesPage extends Component {

    state = {
        showModal: false,
        showConfirm: false,
        rule: {},
        expanded: null,
        search: '',
        rules: [],
        removeSelected: [],
        deleteMultiple: false
    };

    componentDidMount() {
        this.props.getRules(localStorage.getItem("bookid"));
    }

    componentWillReceiveProps(nextProps) {
        if (!nextProps.status.posting && nextProps.status.success) {
            this.setState({ showModal: false });
        }
        if (this.props.rules !== nextProps.rules) {
            const rules = (Boolean(this.state.search.length))
                ? nextProps.rules.filter(rule => rule.Description.toLowerCase().includes(this.state.search)
                    || rule.Definition.find(item => item.Value.toString().toLowerCase().includes(this.state.search)))
                : nextProps.rules;
            this.setState({ rules });
        }
    }

    onDragEnd = result => {
        const { destination, source } = result;

        if (!destination) {
            return;
        }

        if (destination.droppableId === source.droppableId && destination.index === source.index) {
            return;
        }

        if (this.state.rules.length !== this.props.rules.length) {
            this.props.showError('You may not change the order of rules while the rules list is filtered');
            return;
        }

        const ruleList = Array.from(this.props.rules);
        const selectRule = ruleList[source.index]
        ruleList.splice(source.index, 1);
        ruleList.splice(destination.index, 0, selectRule);

        this.props.sortRules(localStorage.getItem("bookid"), ruleList);
    }

    onSearchchanged = value => {
        const search = value.toLowerCase();
        const rules = this.props.rules.filter(rule => rule.Description.toLowerCase().includes(search)
            || rule.Definition.find(item => item.Value.toString().toLowerCase().includes(search)));
        this.setState({ rules, search })
    }

    handleChange = panel => {
        this.setState({
          expanded: (this.state.expanded === panel) ? false : panel
        });
      };

    handleToggleConfirm = (deleteMultiple= false) => {
        this.setState({ showConfirm: !this.state.showConfirm, deleteMultiple: deleteMultiple });
    };

    handleDeleteRule = () => {
        if(this.state.deleteMultiple===true){
            const selectedItems = this.state.removeSelected.slice();
            this.props.deleteRules(localStorage.getItem("bookid"), selectedItems, this.props.rules);
        } else {
            this.props.deleteRule(localStorage.getItem("bookid"), this.state.expanded, this.props.rules);
        }

        this.handleToggleConfirm();
    };

    handleSaveRule = (values) => {
        if (values.Description && (
            (values.transactionAmount && values.amountOperator) || 
            (values.transactionType && values.typeOperator) ||
            (values.transactionDescription && values.descriptionOperator) ||
            (values.transactionReference && values.referenceOperator))) {
            const rule = { 
                RuleId: values.RuleGuid,
                Description: values.Description,
                OrderId: this.props.rules.length,
                Definition: [],
                PaymentReceipt: { Description: '', Allocations: [] }
            };
                    
            rule.Definition.push({ Field: 'MoneyInOut', Operator: values.MoneyInOut, Value: '' });

            if (values.amountOperator && values.transactionAmount) {
                rule.Definition.push({
                    Field: 'Amount', 
                    Operator: (typeof values.amountOperator === 'string') ? values.amountOperator : values.amountOperator.value, 
                    Value: Math.abs(values.transactionAmount * 1).toString() 
                });
            };
  
            if (values.descriptionOperator && values.transactionDescription) {
                rule.Definition.push({
                    Field: 'Description',
                    Operator: (typeof values.descriptionOperator === 'string') ? values.descriptionOperator: values.descriptionOperator.value,
                    Value: values.transactionDescription.toString().replace(/'/g, "''") 
                });
            };

            if (values.referenceOperator && values.transactionReference) {
                rule.Definition.push({
                    Field: 'Reference',
                    Operator: (typeof values.referenceOperator === 'string') ? values.referenceOperator : values.referenceOperator.value,
                    Value: values.transactionReference.toString().replace(/'/g, "''") 
                });
            };

            if (values.typeOperator && values.transactionType) {
                rule.Definition.push({
                    Field: 'Type',
                    Operator: (typeof values.typeOperator === 'string') ? values.typeOperator : values.typeOperator.value,
                    Value: values.transactionType.toString().replace(/'/g, "''")
                });
            };

            const isEqualTo = values.amountOperator && (values.amountOperator === 'Equal' || (values.amountOperator.value === 'Equal'));
            const reverseFactor = values.MoneyInOut === "0" ? -1 : 1;
            const allocateByPercent = values.allocateBy === PERCENTAGE;
            const allocateByPercentAndAmount = values.allocateBy === PERCENTAGEANDAMOUNT;
            const remainder = isEqualTo ? [] : values.Remainder.map(item => ({
                AccountCode: (typeof item.AccountCode === 'string') ? item.AccountCode : item.AccountCode.value,
                ...(item.Percentage && { Percentage: item.Percentage * 1 }),
                TaxCode: (!item.TaxCode) ? undefined : (typeof item.TaxCode === 'string') ? item.TaxCode : item.TaxCode.value,
                Description: item.Description || '',
                Classification: (!item.Classification || typeof item.Classification === 'string') ? item.Classification : item.Classification.value,
                Contact: (!item.Contact || typeof item.Contact === 'string') ? item.Contact : item.Contact.value
            }));
            const allocation = (!isEqualTo && allocateByPercent) ? [] : values.Allocation.map(item => ({
                AccountCode: (typeof item.AccountCode === 'string') ? item.AccountCode : item.AccountCode.value,
                ...(!isEqualTo && item.Amount && { Amount: item.Amount * reverseFactor }),
                ...(isEqualTo && item.Percentage && { Percentage: item.Percentage * 1 }),
                TaxCode: (!item.TaxCode) ? undefined : (typeof item.TaxCode === 'string') ? item.TaxCode : item.TaxCode.value,
                Description: item.Description || '',
                Classification: (!item.Classification || typeof item.Classification === 'string') ? item.Classification : item.Classification.value,
                Contact: (!item.Contact || typeof item.Contact === 'string') ? item.Contact : item.Contact.value
            }));
            if (isEqualTo) {
                rule.PaymentReceipt.Allocations = [ ...allocation ];
            } else {
                if (allocateByPercentAndAmount) rule.PaymentReceipt.Allocations = [ ...allocation, ...remainder ].sort((a, b) => (a.Percentage && !b.Percentage) ? 1 : -1);
                else rule.PaymentReceipt.Allocations = [ ...remainder ];
            }
            this.props.postRule(rule, localStorage.getItem("bookid"));
         }
    }

    openModal = (selectedRule) => {
        let rule = { MoneyInOut: "1", allocateBy: PERCENTAGE, Allocation: [{}], Remainder: [{ Percentage: 100 }] };

        // Shape rule definition data to fit the rules form
        if (selectedRule) {
            const definition = selectedRule.Definition.reduce((definitionObj, item) => {
                if (item.Field === 'Amount') {
                    definitionObj.amountOperator = item.Operator;
                    definitionObj.transactionAmount = item.Value;
                } else if (item.Field === 'Description') {
                    definitionObj.descriptionOperator = item.Operator;
                    definitionObj.transactionDescription = item.Value.replace(/''/g, "'");
                } else if (item.Field === 'Type') {
                    definitionObj.typeOperator = item.Operator;
                    definitionObj.transactionType = item.Value;
                } else if (item.Field === 'Reference') {
                    definitionObj.referenceOperator = item.Operator;
                    definitionObj.transactionReference = item.Value;
                }
                return definitionObj;
            },{});

            const isEqualTo = definition.amountOperator && (definition.amountOperator === 'Equal');
            const isPercentageAndAmount = selectedRule.Allocation && selectedRule.Allocation.some(item => item.Amount);
            let allocation;
            let remainder;
            if (isEqualTo) {
                allocation = selectedRule.Allocation && selectedRule.Allocation.map((item => ({ ...item, Amount:(Math.round((item.Percentage * definition.transactionAmount / 100) * 100) / 100).toFixed(2) })));
            } else {
                if (isPercentageAndAmount) {
                    allocation = selectedRule.Allocation && selectedRule.Allocation.filter(item => item.Amount).map(item => ({...item, Amount: Math.abs(item.Amount) }));
                }
                remainder = selectedRule.Allocation && selectedRule.Allocation.filter(item => item.Percentage);
            }
            rule = { ...selectedRule, ...definition, allocateBy: isPercentageAndAmount ? PERCENTAGEANDAMOUNT : PERCENTAGE, Allocation: allocation || [{}], Remainder: remainder || [{}] };
        } 
        this.setState({ showModal: true, rule })
    }

    closeModal = () => {
       this.setState({ showModal: false })
    }

    removeCheckboxClicked = (value) => {
        if (this.state.removeSelected.includes(value)) {
          this.setState({ removeSelected: this.state.removeSelected.filter(item => item !== value) });
        } else {
          const removeSelected = this.state.removeSelected.slice();
          removeSelected.push(value)
          this.setState({ removeSelected });
        }
      }
    
      selectAllCheckboxClicked = (rows) => {
        const selectedItems = this.state.removeSelected.slice();
        if (selectedItems.length!==rows.length) {
          this.setState({ removeSelected: rows.map(row => row.RuleGuid) });
        } else {
          this.setState({ removeSelected: [] });
        }
      }
  
    render() {
        const { isRah, isR1, transactionCodes, status, contacts, classification, taxTracking } = this.props;
        return (
            <div>
                <div className={cssClasses.mangeRuleHeader}>
                <div className={cssClasses.dFlex}>
                    <div className={cssClasses.width150}><button type="button" className={[cssClasses.btn, cssClasses.btnPrimary].join(' ')} onClick={() => this.openModal()}>Add Rule</button></div>
                    <Search onSearchchanged={this.onSearchchanged} />
                </div>
                <div>
                    <Button style={{float:"right"}} variant="outlined" className={cssClasses.button} onClick={this.props.showTransactions}>Transactions</Button>
                    {this.state.removeSelected.length>0 && <Button style={{float:"right", marginRight:"10px"}} variant="outlined" color="secondary" className={cssClasses.newRuleButton} onClick={() => this.handleToggleConfirm(true)}>Delete</Button>}
                </div>
                </div>
                <div>
                    <div className={[cssClasses.newRuleRow, cssClasses.newRuleHeader].join(' ')}>
        <div style={{width:"80px"}}>{this.state.rules.length>0 && <Checkbox onChange={() => this.selectAllCheckboxClicked(this.state.rules)} checked={this.state.rules.length===this.state.removeSelected.length} />}</div>
                        <div>Rule Title</div>
                        <div>Account Code / Name</div>
                        <div>Type</div>
                    </div>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable">
                            {(provided, snapshot) => (
                                <div ref={provided.innerRef} className={(snapshot.isDraggingOver || this.state.expanded) ? [cssClasses.draggingOver, cssClasses.droppable].join(' ') : cssClasses.droppable}>
                                    {this.state.rules.map((rule, index) => (
                                        <Draggable key={rule.RuleGuid} draggableId={rule.RuleGuid} index={index}>
                                            {(provided, snapshot) => (
                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                    <RuleItem
                                                        rule={rule}
                                                        chart={this.props.transactionCodes.chart}
                                                        expanded={this.state.expanded}
                                                        onExpand={this.handleChange}
                                                        dragging={snapshot.isDragging}
                                                        updateRule={this.openModal}
                                                        deleteRule={this.handleToggleConfirm}
                                                        removeCheckboxClicked={this.removeCheckboxClicked}
                                                        selected={this.state.removeSelected} />   
                                                </div>
                                            )}
                                        </Draggable>))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                    <div className={cssClasses.mangeRuleFooter}>Rules are proccessed in order, drag a rule to change its order and precedence</div>
                </div>
                <Dialog open={this.state.showModal} onClose={this.closeModal} maxWidth={false} fullWidth={false} >
                    <UpdateRuleForm
                        initialValues={this.state.rule}
                        onSubmit={this.handleSaveRule}
                        onCancel={this.closeModal}
                        transactionCodes={transactionCodes}
                        ruleValues={this.state.rule}
                        isRah={isRah}
                        isR1={isR1}
                        isSubmitting={status.posting}
                        contacts={contacts}
                        classification={classification.filter(item => !item.isDisabled)}
                        taxTracking={taxTracking}
                        isCredit={this.props.account.isCreditCard && isRah}
                         />
                </Dialog>

                <Dialog open={this.state.showConfirm} onClose={this.handleToggleConfirm}>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.deleteMultiple && this.state.removeSelected.length>1?'Confirm you want to delete these rules.':'Confirm you want to delete this rule.'}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleToggleConfirm}>Cancel</Button>
                        <Button onClick={this.handleDeleteRule} color="primary" autoFocus>Confirm</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
      rules: state.rules,
      status: state.status,
      transactionCodes: state.transactions.transactionCodes,
      contacts: state.transactions.contacts,
      classification: state.transactions.classification
    };
  }
  
export default connect(mapStateToProps, actions)(ManageRulesPage);



// WEBPACK FOOTER //
// ./src/components/Rules/ManageRulesPage.js